import { useEffect, useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import NewsFeed from './components/NewsFeed';
import Timeline from './components/Timeline';
import Specials from './components/Specials';
import About from './components/About';
import Faq from './components/Faq';
import Footer from './components/Footer';

function BackToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!show) return null;
  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className="fixed bottom-6 right-5 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-orange-600 text-white shadow-[0_8px_20px_rgba(232,88,43,0.35)] transition-transform hover:-translate-y-1 md:right-8"
      aria-label="返回顶部"
    >
      <i className="ri-arrow-up-line text-lg"></i>
    </button>
  );
}

export default function Home() {
  return (
    <div id="top" className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <NewsFeed />
        <Timeline />
        <Specials />
        <About />
        <Faq />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}